module.exports = __webpack_public_path__ + "assets/img/30ed70fa34ddd3491ee9fd88180c0934.svg";